// TextareaComposer — saf yardımcılar + sabitler (hook/state YOK).
// God-module split (SOLID): TextareaComposer.jsx 1417 satırdı; bu ~200 satırlık
// pure sabit/fonksiyon bloğu ayrıldı (davranış değişmez — sadece taşındı).

export const buildFileItem = (file) => ({
  id: `${Date.now()}-${file.name}-${Math.random().toString(36).slice(2, 7)}`,
  file,
  name: file.name,
  type: file.type,
  url: URL.createObjectURL(file),
});

export const buildAudioItem = (blob) => ({
  id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
  blob,
  type: blob.type || "audio/webm",
  url: URL.createObjectURL(blob),
});

export const STYLE_OPTIONS = [
  { label: "p", block: "p" },
  { label: "Alıntı", block: "blockquote", style: { fontStyle: "italic" } },
  {
    label: "Önbiçimli",
    block: "pre",
    style: { fontFamily: "JetBrains Mono, monospace" },
  },
  { label: "Başlık 1", block: "h1", style: { fontSize: "32px" } },
  { label: "Başlık 2", block: "h2", style: { fontSize: "30px" } },
  { label: "Başlık 3", block: "h3", style: { fontSize: "28px" } },
  { label: "Başlık 4", block: "h4", style: { fontSize: "26px" } },
  { label: "Başlık 5", block: "h5", style: { fontSize: "24px" } },
  { label: "Başlık 6", block: "h6", style: { fontSize: "22px" } },
];

export const FONT_OPTIONS = [
  "Rubik",
  "Arial",
  "Arial Black",
  "Comic Sans MS",
  "Courier New",
  "Helvetica",
  "Impact",
  "Times New Roman",
  "Verdana",
];

export const TABLE_GRID_SIZE = 6;

export const LINE_HEIGHT_OPTIONS = ["1.0", "1.2", "1.4", "1.5", "1.6", "1.8", "2.0", "3.0"];

export const COLOR_PALETTE = [
  "#000000", "#434343", "#666666", "#999999", "#b7b7b7",
  "#cccccc", "#d9d9d9", "#efefef", "#f3f3f3", "#ffffff",
  "#980000", "#ff0000", "#ff9900", "#ffff00", "#00ff00",
  "#00ffff", "#4a86e8", "#0000ff", "#9900ff", "#ff00ff",
  "#e6b8af", "#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3",
  "#d0e0e3", "#c9daf8", "#cfe2f3", "#d9d2e9", "#ead1dc",
  "#dd7e6b", "#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8",
  "#a2c4c9", "#a4c2f4", "#9fc5e8", "#b4a7d6", "#d5a6bd",
  "#cc4125", "#e06666", "#f6b26b", "#ffd966", "#93c47d",
  "#76a5af", "#6d9eeb", "#6fa8dc", "#8e7cc3", "#c27ba0",
  "#a61c00", "#cc0000", "#e69138", "#f1c232", "#6aa84f",
  "#45818e", "#3c78d8", "#3d85c6", "#674ea7", "#a64d79",
  "#85200c", "#990000", "#b45f06", "#bf9000", "#38761d",
  "#134f5c", "#1155cc", "#0b5394", "#351c75", "#741b47",
  "#5b0f00", "#660000", "#783f04", "#7f6000", "#274e13",
  "#0c343d", "#1c4587", "#073763", "#20124d", "#4c1130",
];

export const BLOCK_SELECTOR = "p,div,blockquote,pre,h1,h2,h3,h4,h5,h6,li";

export const defaultLinkForm = {
  text: "",
  url: "",
  openInNewWindow: false,
  useDefaultProtocol: true,
};

export const escapeHtml = (value = "") =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const escapeAttr = (value = "") => escapeHtml(value).replace(/\n/g, " ");

export const toRgba = (hexColor, opacity) => {
  const clean = hexColor.replace("#", "").trim();
  const value =
    clean.length === 3
      ? clean
          .split("")
          .map((item) => `${item}${item}`)
          .join("")
      : clean;

  if (value.length !== 6) return hexColor;

  const red = parseInt(value.slice(0, 2), 16);
  const green = parseInt(value.slice(2, 4), 16);
  const blue = parseInt(value.slice(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
};

export const normalizeUrl = (url, useDefaultProtocol) => {
  const trimmed = (url || "").trim();
  if (!trimmed) return "";
  if (!useDefaultProtocol || /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(trimmed)) {
    return trimmed;
  }
  return `https://${trimmed}`;
};

export const normalizeHtmlForCodeView = (rawHtml) => {
  const html = (rawHtml || "").trim();
  if (!html) return "";
  if (typeof document === "undefined") return html;

  const container = document.createElement("div");
  container.innerHTML = html;

  const normalized = Array.from(container.childNodes)
    .map((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const lines = (node.textContent || "").split(/\n+/).filter((line) => line.trim());
        return lines.map((line) => `<p>${escapeHtml(line)}</p>`).join("");
      }

      if (node.nodeType !== Node.ELEMENT_NODE) return "";

      const element = node;
      const tag = element.tagName.toLowerCase();
      if (tag === "div") {
        const content = element.innerHTML.trim();
        return `<p>${content || "<br/>"}</p>`;
      }
      if (tag === "br") {
        return "<p><br/></p>";
      }
      return element.outerHTML;
    })
    .join("");

  return normalized || html;
};
